import React from 'react';
import { Property } from '../../../interfaces/interfaces';
import FourThreeImage from '../../Shared/FourThreeImage';
import ListingStatus from '../../Shared/ListingStatus/ListingStatus';
import HouseMissingImage from '../../Shared/img/single-family.svg';
import * as AppState from '../../../AppState';
import { useRecoilValue } from 'recoil';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './ImageGallery.scss';
import {isCapCenterOffice} from '../../../utilities/util';


interface ImagesProps {
	images: any[];
	property: Property;
	onImageClick: (value: number) => void;
	onCounterClick?: () => void;
	capCenter: boolean | undefined;
	onMarketDate: Date | undefined;
	standardStatus: string | undefined;
	staticMapSrc: string;
	photoCount: number;
	closeDate: Date;
	addressText: string;
}

const ImageGallery = (props: ImagesProps) => {
	const userOnMobile = useRecoilValue(AppState.gsIsMobile);
	const selectedProperty = props.property;

	const addressArray: Array<{ label: string; value: string }> = selectedProperty.normalized_address?.parsed;

	const Photos = { primaryImageSrc: props.staticMapSrc, secondaryImageSrc: HouseMissingImage, tertiaryImageSrc: HouseMissingImage };

	if (props.photoCount === 1) {
		Photos.primaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 0)?.url || selectedProperty.Photos[0].url;
		Photos.secondaryImageSrc = props.staticMapSrc;
		Photos.tertiaryImageSrc = HouseMissingImage;
	} else if (props.photoCount === 2) {
		Photos.primaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 0)?.url || selectedProperty.Photos[0].url;
		Photos.secondaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 1)?.url || selectedProperty.Photos[1].url;
		Photos.tertiaryImageSrc = props.staticMapSrc;
	} else if (props.photoCount > 3) {
		Photos.primaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 0)?.url || selectedProperty.Photos[0].url;
		Photos.secondaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 1)?.url || selectedProperty.Photos[1].url;
		Photos.tertiaryImageSrc = selectedProperty.Photos?.find((p: any) => p.order === 2)?.url || selectedProperty.Photos[2].url;
	}

	const address: any = {};

	addressArray?.map(item => {
		address[item.label] = item.value;
	});

	return (
		<div className={`image-gallery__main-image--details-view p-0 pe-1`}>
			<div className="position-relative" style={{height: '100%'}}>
				<FourThreeImage
					src={Photos.primaryImageSrc}
					onClick={() => props.onImageClick(1)}
					hoverEffects
					alt={props.addressText}
				/>

				<div className="image-gallery__image-count position-absolute" onClick={props.onCounterClick}>
				See all {selectedProperty.Photos ? (selectedProperty.Photos.length + 1) + ' ' : ''}photos
				</div>
				<ListingStatus
					isCapcenterPurchase={isCapCenterOffice(selectedProperty?.BuyerOfficeMlsId, selectedProperty?.OriginatingSystemName)}
					isCapcenterListing={props.capCenter}
					onMarket={props.onMarketDate}
					listingStatus={props.standardStatus}
					closeDate={props.closeDate}
				/>
				{/* </div>
			</div>
			<div className="d-none d-sm-flex col-sm-4 ps-sm-1 flex-wrap align-content-between">
				<div className="w-100 image-gallery__secondary-image-wrapper">
					<FourThreeImage
						className='image-gallery__secondary-image image-gallery__secondary-image--first'
						src={Photos.secondaryImageSrc}
						onClick={() => props.onImageClick(2)}
						hoverEffects
						alt={props.addressText + ' secondary image on CapCenter Home Search'}
					/>
				</div>
				<div className="w-100 image-gallery__secondary-image-wrapper">
					<FourThreeImage
						className='image-gallery__secondary-image image-gallery__secondary-image--last'
						src={Photos.tertiaryImageSrc}
						onClick={() => props.onImageClick(props.photoCount === 0 ? 1 : 3)}
						hoverEffects
						alt={props.addressText + ' tertiary image on CapCenter Home Search'}
					/>
				</div>
			</div> */}
			</div>
		</div>
	);
};

export default ImageGallery;
